import { useState } from 'react'
import type { WidgetSettings } from '../../stores/dashboardLayoutStore'

interface Props {
    settings: WidgetSettings
    onSave: (settings: Partial<WidgetSettings>) => void
    onClose: () => void
}

export default function DailyTargetConfigModal({ settings, onSave, onClose }: Props) {
    const [mode, setMode] = useState<'lastYearWeeklyAvg' | 'fixed' | 'lastYearWeeklyCumulative'>(
        (settings.dailyTargetMode as any) || 'lastYearWeeklyAvg'
    )
    const [multiplier, setMultiplier] = useState<number>(settings.dailyTargetMultiplier || 0)
    const [fixedAmount, setFixedAmount] = useState<number>(settings.dailyTargetFixedAmount || 10000)

    const handleSave = () => {
        onSave({
            dailyTargetMode: mode,
            dailyTargetMultiplier: multiplier,
            dailyTargetFixedAmount: fixedAmount
        })
        onClose()
    }

    return (
        <div className="admin-save-overlay" style={{ zIndex: 10000 }}>
            <div className="admin-save-dialog" onClick={e => e.stopPropagation()} style={{ maxWidth: '400px' }}>
                <h3>Manage Daily Target</h3>
                <p style={{ fontSize: '13px', color: 'var(--color-text-tertiary)', marginBottom: '1rem' }}>
                    Configure how the Daily Performance Target is calculated.
                </p>

                <div style={{ marginBottom: '1rem' }}>
                    <label style={{ display: 'block', fontSize: '12px', color: 'var(--color-text-tertiary)', marginBottom: '4px' }}>Target Preset</label>
                    <select 
                        value={mode} 
                        onChange={e => setMode(e.target.value as any)}
                        style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid var(--color-border)', background: 'var(--color-bg)', color: 'var(--color-text)', fontSize: '14px' }}
                    >
                        <option value="lastYearWeeklyAvg">Last Year's Weekly Average</option>
                        <option value="lastYearWeeklyCumulative">Last Year's Weekly Cumulative Total</option>
                        <option value="fixed">Fixed Target</option>
                    </select>
                </div>

                {(mode === 'lastYearWeeklyAvg' || mode === 'lastYearWeeklyCumulative') && (
                    <div style={{ marginBottom: '1rem' }}>
                        <label style={{ display: 'block', fontSize: '12px', color: 'var(--color-text-tertiary)', marginBottom: '4px' }}>
                            Multiplier (Plus X Percent)
                        </label>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <input 
                                type="number" 
                                value={multiplier} 
                                onChange={e => setMultiplier(parseFloat(e.target.value) || 0)}
                                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid var(--color-border)', background: 'var(--color-bg)', color: 'var(--color-text)', fontSize: '14px' }}
                            />
                            <span>%</span>
                        </div>
                        <p style={{ fontSize: '12px', color: 'var(--color-text-tertiary)', marginTop: '4px' }}>
                            Example: Enter 5 for a 5% increase.
                        </p>
                    </div>
                )}

                {mode === 'fixed' && (
                    <div style={{ marginBottom: '1rem' }}>
                        <label style={{ display: 'block', fontSize: '12px', color: 'var(--color-text-tertiary)', marginBottom: '4px' }}>
                            Fixed Daily Amount ($)
                        </label>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span>$</span>
                            <input 
                                type="number" 
                                value={fixedAmount} 
                                onChange={e => setFixedAmount(parseFloat(e.target.value) || 0)}
                                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid var(--color-border)', background: 'var(--color-bg)', color: 'var(--color-text)', fontSize: '14px' }}
                            />
                        </div>
                    </div>
                )}

                <div className="admin-save-actions" style={{ marginTop: '1.5rem' }}>
                    <button className="btn btn-secondary" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary" onClick={handleSave}>
                        Save Target
                    </button>
                </div>
            </div>
        </div>
    )
}
